import React from 'react';
import MetricDropdown from './MetricDropdown';
import MetricLensTable from './MetricLensTable';
import UnitToggle from './UnitToggle';
import {
  StyledTopWrapper,
  StyledMLTable,
  StyledMLTableTopWrapper,
} from './styled';
import { Space } from 'antd';
import { FlexFill } from '@components/common/Utils/Layout';
// eslint-disable-next-line react/display-name
export default () => (
  <StyledTopWrapper>
    <StyledMLTableTopWrapper>
      <FlexFill />
      <MetricDropdown />
      <UnitToggle />
    </StyledMLTableTopWrapper>
    <StyledMLTable>
      <MetricLensTable />
    </StyledMLTable>
  </StyledTopWrapper>
);
